/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_Error_LoadingInputs */

const en_options_integrations_error_loading = /** @type {(inputs: Options_Integrations_Error_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading integration settings. Please try again.`)
};

const fr_options_integrations_error_loading = /** @type {(inputs: Options_Integrations_Error_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement des paramètres d'intégration. Veuillez réessayer.`)
};

const de_options_integrations_error_loading = /** @type {(inputs: Options_Integrations_Error_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden der Integrationseinstellungen. Bitte versuchen Sie es erneut.`)
};

const it_options_integrations_error_loading = /** @type {(inputs: Options_Integrations_Error_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante il caricamento delle impostazioni di integrazione. Riprova.`)
};

const ru_options_integrations_error_loading = /** @type {(inputs: Options_Integrations_Error_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при загрузке настроек интеграции. Пожалуйста, попробуйте еще раз.`)
};

const es_options_integrations_error_loading = /** @type {(inputs: Options_Integrations_Error_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar la configuración de integración. Inténtalo de nuevo.`)
};

const zh_cn2_options_integrations_error_loading = /** @type {(inputs: Options_Integrations_Error_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载集成设置时出错。请重试。`)
};

const ja_options_integrations_error_loading = /** @type {(inputs: Options_Integrations_Error_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`統合設定の読み込み中にエラーが発生しました。もう一度お試しください。`)
};

const hi_options_integrations_error_loading = /** @type {(inputs: Options_Integrations_Error_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एकीकरण सेटिंग्स लोड करने में त्रुटि। कृपया पुनः प्रयास करें।`)
};

const pt_pt2_options_integrations_error_loading = /** @type {(inputs: Options_Integrations_Error_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao carregar as configurações de integração. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Error loading integration settings. Please try again." |
*
* @param {Options_Integrations_Error_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_error_loading = /** @type {((inputs?: Options_Integrations_Error_LoadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_Error_LoadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_integrations_error_loading(inputs)
	if (locale === "de") return de_options_integrations_error_loading(inputs)
	if (locale === "it") return it_options_integrations_error_loading(inputs)
	if (locale === "ru") return ru_options_integrations_error_loading(inputs)
	if (locale === "es") return es_options_integrations_error_loading(inputs)
	if (locale === "zh-CN") return zh_cn2_options_integrations_error_loading(inputs)
	if (locale === "ja") return ja_options_integrations_error_loading(inputs)
	if (locale === "hi") return hi_options_integrations_error_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_options_integrations_error_loading(inputs)
	return en_options_integrations_error_loading(inputs)
});